export const CLEAN_DEFAULT_ID = 'CLEAN_DEFAULT_ID';

export const DASHBOARD_LIST_READY = 'DASHBOARD_LIST_READY';

export const DASHBOARD_UPDATE_LIST_ITEM = 'DASHBOARD_UPDATE_LIST_ITEM';

export const SET_IS_EMPTY_LIST = 'SET_IS_EMPTY_LIST';
